export interface AssistanceFooterProps {
  heading?: string;
  linkText?: string;
  meetingUrl?: string;
}

export const AssistanceFooter = ({
  heading = 'Need assistance?',
  linkText = 'Treezpay representative',
  meetingUrl = 'https://calendly.com/treezpay',
}: AssistanceFooterProps) => {
  return (
    <div className="flex items-center justify-start px-11 py-2 xl:py-6 border-t border-gray-blue-10 w-full">
      <div className="flex flex-col">
        <span className="text-sm md:text-base font-medium leading-5 text-gray-blue-90 mb-1">
          {heading}
        </span>

        <div className="text-xs md:text-sm font-normal leading-5 text-gray-blue-60">
          <span>Setup a meeting with a </span>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={meetingUrl}
            className="text-dark-green-link underline hover:no-underline"
            aria-label={`Schedule a meeting with ${linkText}`}
          >
            {linkText}
          </a>
        </div>
      </div>
    </div>
  );
};
